import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

interface Props {
  amount?: string;
  containerStyle?: StyleProp<ViewStyle>;
  emphasizeName?: boolean;
  emphasizePercentDailyValue?: boolean;
  name: string;
  percentDailyValue?: number | null;
  unitName?: string | null;
}

export const NutritionLabelNutrientRow: React.FC<Props> = ({
  amount,
  containerStyle,
  emphasizeName,
  emphasizePercentDailyValue,
  name,
  percentDailyValue,
  unitName,
}) => {
  const [styles] = useStyles();
  return (
    <View style={[styles.container, containerStyle]}>
      <View style={styles.nutrient}>
        <Text
          style={[styles.text, emphasizeName ? FONTS.helveticaBlack : null]}
        >
          {name}
        </Text>
        {amount ? (
          <Text style={styles.text}>
            {' '}
            {amount}
            {unitName || ''}
          </Text>
        ) : null}
      </View>
      {typeof percentDailyValue === 'number' ? (
        <Text
          style={[
            styles.text,
            emphasizePercentDailyValue ? FONTS.helveticaBlack : null,
          ]}
        >
          {percentDailyValue}%
        </Text>
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'baseline',
    borderBottomColor: theme.colors.black,
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 2,
  },
  nutrient: {
    alignItems: 'baseline',
    flexDirection: 'row',
  },
  text: {
    ...FONTS.helvetica,
    fontSize: 14,
    lineHeight: 14,
  },
}));
